export const GET_TITLES = "GET_TITLES";
export const GET_POST = "GET_POST";
export const ADD_POST = "ADD_POST";
export const EDIT_POST = "EDIT_POST";
export const DELETE_POST = "DELETE_POST";
export const GET_COMMENTS = "GET_COMMENTS";
export const ADD_COMMENT = "ADD_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const START_LOAD = "START_LOAD";
export const END_LOAD = "END_LOAD";
export const CHANGE_VOTE = "CHANGE_VOTE";